var $ = require('jquery');

$(function(){
    'use scrict';
    
    //プレイヤー変数
    var player;
	
    //オブジェクト生成
    function youtubeAPIInit() {
        var scriptTag = document.createElement('script');
        scriptTag.src = "https://www.youtube.com/iframe_api";
        var fsTag = document.getElementsByTagName('script')[0];
        fsTag.parentNode.insertBefore(scriptTag, fsTag);
        window.onYouTubeIframeAPIReady = function(){
            player = new YT.Player('player', {
                height:'540',
                width:'960',
                videoId:'6W9J7aDqe7g',
                playerVars:{
                    autohide:1,
                    controls:1,
                    modestbranding:1,
                    iv_load_policy:3,
                    showinfo:0,
                    rel:0,
                    loop: 1,
                    playlist:'6W9J7aDqe7g',
                    autoplay:1
                }
            });
        };
    }

    //モーダル
    var modal = {}, $lay, $content;
    modal.inner = function() {
        if($("#modal__overlay")[0]) return false;
        $("body").append('<div id="modal__overlay"></div>');
        $lay = $("#modal__overlay");
        $content = $("#modal__content");
        $lay.fadeIn("slow");
        youtubeAPIInit();
        this.resize();
        $content.fadeIn("fast");
        $lay.unbind().click(function() {
            player.pauseVideo();
            $content.add($lay).fadeOut("fast",function(){
                $lay.remove();
            });
        });
    };
	
    //リサイズ処理
    modal.resize = function(){
        var $winWidth = $(window).width();
        var $winHeight = $(window).height();
        var $contentOuterWidth = $("#modal__content").outerWidth();
        var $contentOuterHeight = $("#modal__content").outerHeight();
        $("#modal__content").css({
            "left": (($winWidth - $contentOuterWidth) / 2) + "px",
            "top": (($winHeight - $contentOuterHeight) / 2) + "px"
        });
    }
	
    //クリック処理
    $("#modal__open").click(function(){
        modal.inner();
        player.playVideo();
    });
    $(window).resize(modal.resize);
});